(() => {
  if (window.__usCateringBound) return;
  window.__usCateringBound = true;
  const elements = () => {
    const card = document.querySelector('[data-us-catering-form]');
    if (!card) return null;
    const select = card.querySelector('select[name="contact[Preferred restaurant]"]');
    const status = card.querySelector('[data-us-catering-prefill-status]');
    return select && status ? { select, status } : null;
  };
  const showSelection = ({ select, status }) => {
    const option = select.options[select.selectedIndex];
    status.textContent = option && option.dataset.usCateringLocation
      ? `${option.textContent.trim()} ${status.dataset.selectedSuffix}`
      : '';
  };
  const chooseLocation = (slug, moveFocus) => {
    const current = elements();
    if (!current) return false;
    const { select } = current;
    const option = Array.from(select.options).find(item => item.dataset.usCateringLocation === slug);
    if (!option) return false;
    select.value = option.value;
    showSelection(current);
    if (moveFocus) {
      const target = document.getElementById('catering-inquiry');
      if (target) target.scrollIntoView({ block: 'start', behavior: 'auto' });
      select.focus({ preventScroll: true });
    }
    return true;
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-us-catering-location]');
    if (!link || !chooseLocation(link.dataset.usCateringLocation, true)) return;
    event.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set('catering_location', link.dataset.usCateringLocation);
    url.hash = 'catering-inquiry';
    window.history.replaceState(null, '', url.toString());
  });
  document.addEventListener('change', event => {
    const current = elements();
    if (current && event.target === current.select) showSelection(current);
  });
  const restoreSelection = () => {
    const requested = new URLSearchParams(window.location.search).get('catering_location');
    if (requested) chooseLocation(requested, false);
  };
  document.addEventListener('shopify:section:load', restoreSelection);
  restoreSelection();
})();
